/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdBackTopProps } from './type';

export const backTopDefaultProps: TdBackTopProps = {
  fixed: true,
  icon: true,
  text: '',
  theme: 'round',
  visibilityHeight: 200,
};
